// extracted by mini-css-extract-plugin
export default {"notification":"Notification_notification__rd9YH","error":"Notification_error__GJWEc","success":"Notification_success__ATcXF"};